<template>
	<transition name="fade">
		<div class="booking-menu" v-if="show" :class="'booking-menu--active'">
			<!-- :class="dropdown" -->
			<!-- style="display:block!important;" class="booking-menu--dropdown" v-on:mouseover="bookingMenuVisible = true" v-on:mouseleave="bookingMenuVisible = false" v-show="bookingMenuVisible" -->
			<div class="grid-container">
				<div class="booking-menu__content">
					<ul>
						<li class="booking-menu__item" v-if="useRouterLink()">
							<!-- booking-menu__item--active -->
							<router-link
								:to="{ name: 'search' }"
								@click.native="closeBookingMenu"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.accommodation.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.accommodation.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.84 71.5h2a1 1 0 000-2h-2a1 1 0 000 2zM57.84 84.5h-16a1 1 0 000 2h16a1 1 0 000-2z"/><path class="cls-1" d="M67.84 33.55v-15a1 1 0 00-1-1h-7a1 1 0 00-1 1v6.05L52.32 18a3.59 3.59 0 00-5 0L21 44.37a3.51 3.51 0 104.94 5l2.87-2.87v4.08a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3h-4a1 1 0 000 2h50a1 1 0 000-2h-4v-3a3.48 3.48 0 000-6.94v-3.11a3.48 3.48 0 000-6.94v-3.06a3.48 3.48 0 000-6.94v-4.08l2.87 2.87a3.52 3.52 0 104.95-5zm-7-14h5v12l-5-5zm-19 61h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm0-5h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm14 15h-12v-19h12zm1-21h-14a1 1 0 00-1 1h-11v-3h38v3h-11a1 1 0 00-1-1zm1 8h11v3h-11zm11 13h-11v-3h11zM72.09 74a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5h-41.5a1.5 1.5 0 010-3h41.5a1.5 1.5 0 011.5 1.5zm-34.25-8.5h-7v-1l1.95-2h5.05a1 1 0 000-2h-3.05l8-8h6.52a1 1 0 000-2h-4.52l5.05-5.05 15.06 15h-3.06a1 1 0 000 2h5.06l1.94 2v1h-7a1 1 0 000 2h7v3h-11v-12a1 1 0 00-1-1h-14a1 1 0 00-1 1v12h-11v-3h7a1 1 0 000-2zm13-1.5v-4.5h5V44zm5 2v4.5h-5V46zm-12-2v-4.5h5v4.55zm5 2v4.5h-5V46zm28.41 1.9a1.5 1.5 0 01-2.12 0L68 40.79 50.55 23.33a1 1 0 00-1.41 0l-7.47 7.46L24.56 47.9a1.5 1.5 0 11-2.12-2.12l26.34-26.34a1.5 1.5 0 012.13 0l26.34 26.34a1.51 1.51 0 010 2.12zM85.34 2h-9a3.52 3.52 0 00-3.5 3.5v2a1.5 1.5 0 01-1.5 1.5h-5a3.52 3.52 0 00-3.5 3.5v2a1 1 0 002 0v-2a1.5 1.5 0 011.5-1.5h5a3.5 3.5 0 003.5-3.5v-2a1.5 1.5 0 011.5-1.5h9a1 1 0 000-2z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.accomodation') }}
								</span>
							</router-link>
						</li>
						<li class="booking-menu__item" v-else>
							<!-- booking-menu__item--active -->
							<a
								:href="
									isEn() + `/${$t('routes.book')}/${$t('routes.accommodation')}`
								"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.accommodation.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.accommodation.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.84 71.5h2a1 1 0 000-2h-2a1 1 0 000 2zM57.84 84.5h-16a1 1 0 000 2h16a1 1 0 000-2z"/><path class="cls-1" d="M67.84 33.55v-15a1 1 0 00-1-1h-7a1 1 0 00-1 1v6.05L52.32 18a3.59 3.59 0 00-5 0L21 44.37a3.51 3.51 0 104.94 5l2.87-2.87v4.08a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3h-4a1 1 0 000 2h50a1 1 0 000-2h-4v-3a3.48 3.48 0 000-6.94v-3.11a3.48 3.48 0 000-6.94v-3.06a3.48 3.48 0 000-6.94v-4.08l2.87 2.87a3.52 3.52 0 104.95-5zm-7-14h5v12l-5-5zm-19 61h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm0-5h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm14 15h-12v-19h12zm1-21h-14a1 1 0 00-1 1h-11v-3h38v3h-11a1 1 0 00-1-1zm1 8h11v3h-11zm11 13h-11v-3h11zM72.09 74a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5h-41.5a1.5 1.5 0 010-3h41.5a1.5 1.5 0 011.5 1.5zm-34.25-8.5h-7v-1l1.95-2h5.05a1 1 0 000-2h-3.05l8-8h6.52a1 1 0 000-2h-4.52l5.05-5.05 15.06 15h-3.06a1 1 0 000 2h5.06l1.94 2v1h-7a1 1 0 000 2h7v3h-11v-12a1 1 0 00-1-1h-14a1 1 0 00-1 1v12h-11v-3h7a1 1 0 000-2zm13-1.5v-4.5h5V44zm5 2v4.5h-5V46zm-12-2v-4.5h5v4.55zm5 2v4.5h-5V46zm28.41 1.9a1.5 1.5 0 01-2.12 0L68 40.79 50.55 23.33a1 1 0 00-1.41 0l-7.47 7.46L24.56 47.9a1.5 1.5 0 11-2.12-2.12l26.34-26.34a1.5 1.5 0 012.13 0l26.34 26.34a1.51 1.51 0 010 2.12zM85.34 2h-9a3.52 3.52 0 00-3.5 3.5v2a1.5 1.5 0 01-1.5 1.5h-5a3.52 3.52 0 00-3.5 3.5v2a1 1 0 002 0v-2a1.5 1.5 0 011.5-1.5h5a3.5 3.5 0 003.5-3.5v-2a1.5 1.5 0 011.5-1.5h9a1 1 0 000-2z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.accomodation') }}
								</span>
							</a>
						</li>
						<li class="booking-menu__item" v-if="useRouterLink()">
							<router-link
								:to="{ name: 'skipass' }"
								@click.native="closeBookingMenu"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skipass.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skipass.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M38.45 72.23h1v7.36h-1zM45.22 72.23h3v7.36h-3zM41.04 72.23h1v7.36h-1zM30.98 72.23h3v7.36h-3zM37 57.72a3.7 3.7 0 00-1.79-.37h-4.28v9.34h1.92v-3.11h2.34a3.55 3.55 0 001.81-.39 1.9 1.9 0 00.85-1.06 5.89 5.89 0 00.21-1.67 5.47 5.47 0 00-.22-1.71 1.79 1.79 0 00-.84-1.03zm-1 3.68a.66.66 0 01-.46.4 4.19 4.19 0 01-1.17.11h-1.52V59h1.58a4.52 4.52 0 011.16.11.63.63 0 01.45.39 3.31 3.31 0 01.1.94 2.83 2.83 0 01-.14.96zM35.86 72.23h1v7.36h-1zM56.58 72.23h1v7.36h-1zM61.64 62.31a3 3 0 001.38.47L65 63a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.81 2.81 0 010 .58 2.44 2.44 0 010 .54.57.57 0 01-.22.33 1.2 1.2 0 01-.58.21 6.52 6.52 0 01-1.08.06c-.78 0-1.73-.06-2.85-.16v1.61a23 23 0 003.42.22 6.81 6.81 0 001.8-.2 1.85 1.85 0 001-.84 3.55 3.55 0 00.41-1.94 3.84 3.84 0 00-.32-1.8 1.4 1.4 0 00-.64-.61 3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.36.36 0 01-.24-.25 1.94 1.94 0 01-.06-.59 1.57 1.57 0 01.06-.53.44.44 0 01.27-.28 4 4 0 011.61-.21 19.55 19.55 0 012.65.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.89.19 2 2 0 00-1.16.81 3.11 3.11 0 00-.44 1.81 4.24 4.24 0 00.26 1.37 1.7 1.7 0 00.64.89zM66.95 72.23h1v7.36h-1zM59.18 72.23h1v7.36h-1z"/><path class="cls-1" d="M73.63 54.13V20.42a4 4 0 00-4-4H56l5-11a1 1 0 00-1.8-.84l-5.44 11.84h-8.9L39.43 4.58a1 1 0 00-.82-.58 1 1 0 00-.91.42 1 1 0 00-.09 1l5 11H29a4 4 0 00-4 4v61.35a4 4 0 004 4h40.63a4 4 0 004-4V54.65a1.14 1.14 0 000-.52zM27 20.42a2 2 0 012-2h14.58l2.84 6.17a4.92 4.92 0 101.81-.84l-2.45-5.33h23.85a2 2 0 012 2v31.51L59 39.33a1 1 0 00-.71-.29 1 1 0 00-.7.29L51.9 45 40.2 33.34a1 1 0 00-1.42 0L27 45.12zm23.22 7.67l-1.12-2.45h.21a2.89 2.89 0 11-2 .84l1.09 2.44a1 1 0 00.91.58 1 1 0 00.42-.09 1 1 0 00.49-1.32zm21.41 53.67a2 2 0 01-.58 1.42 2 2 0 01-1.42.59H29a2 2 0 01-2-2V48l12.49-12.54 16.78 16.78a1 1 0 101.42-1.42l-4.37-4.36 5-5 13.31 13.3z"/><path class="cls-1" d="M50.11 72.23h1v7.36h-1zM42.88 57.35l-3.16 9.34h1.94l.67-2H46l.68 2h2l-3.17-9.34zm0 5.65l1.26-3.83h.07L45.45 63zM62.06 72.23h3v7.36h-3zM53.99 72.23h1v7.36h-1zM56.94 61.4a3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.42.42 0 01-.24-.25 2.32 2.32 0 010-.59 1.87 1.87 0 010-.53.53.53 0 01.27-.28 4 4 0 011.62-.21 19.41 19.41 0 012.64.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.88.19 2 2 0 00-1.17.81 3.11 3.11 0 00-.42 1.81 4.54 4.54 0 00.19 1.37 1.7 1.7 0 00.67.89 3.24 3.24 0 001.38.47l2 .23a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.32 2.32 0 010 .59 2.44 2.44 0 010 .54.64.64 0 01-.23.33 1.2 1.2 0 01-.58.21 6.34 6.34 0 01-1.07.06c-.79 0-1.74-.06-2.85-.16v1.61a23 23 0 003.42.22 6.74 6.74 0 001.79-.2 1.84 1.84 0 001.1-.85 3.73 3.73 0 00.4-1.94 3.84 3.84 0 00-.32-1.8 1.46 1.46 0 00-.72-.62z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skipass') }}
								</span>
							</router-link>
						</li>
						<li class="booking-menu__item" v-else>
							<a
								:href="isEn() + `/${$t('routes.book')}/${$t('routes.skipass')}`"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skipass.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skipass.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M38.45 72.23h1v7.36h-1zM45.22 72.23h3v7.36h-3zM41.04 72.23h1v7.36h-1zM30.98 72.23h3v7.36h-3zM37 57.72a3.7 3.7 0 00-1.79-.37h-4.28v9.34h1.92v-3.11h2.34a3.55 3.55 0 001.81-.39 1.9 1.9 0 00.85-1.06 5.89 5.89 0 00.21-1.67 5.47 5.47 0 00-.22-1.71 1.79 1.79 0 00-.84-1.03zm-1 3.68a.66.66 0 01-.46.4 4.19 4.19 0 01-1.17.11h-1.52V59h1.58a4.52 4.52 0 011.16.11.63.63 0 01.45.39 3.31 3.31 0 01.1.94 2.83 2.83 0 01-.14.96zM35.86 72.23h1v7.36h-1zM56.58 72.23h1v7.36h-1zM61.64 62.31a3 3 0 001.38.47L65 63a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.81 2.81 0 010 .58 2.44 2.44 0 010 .54.57.57 0 01-.22.33 1.2 1.2 0 01-.58.21 6.52 6.52 0 01-1.08.06c-.78 0-1.73-.06-2.85-.16v1.61a23 23 0 003.42.22 6.81 6.81 0 001.8-.2 1.85 1.85 0 001-.84 3.55 3.55 0 00.41-1.94 3.84 3.84 0 00-.32-1.8 1.4 1.4 0 00-.64-.61 3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.36.36 0 01-.24-.25 1.94 1.94 0 01-.06-.59 1.57 1.57 0 01.06-.53.44.44 0 01.27-.28 4 4 0 011.61-.21 19.55 19.55 0 012.65.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.89.19 2 2 0 00-1.16.81 3.11 3.11 0 00-.44 1.81 4.24 4.24 0 00.26 1.37 1.7 1.7 0 00.64.89zM66.95 72.23h1v7.36h-1zM59.18 72.23h1v7.36h-1z"/><path class="cls-1" d="M73.63 54.13V20.42a4 4 0 00-4-4H56l5-11a1 1 0 00-1.8-.84l-5.44 11.84h-8.9L39.43 4.58a1 1 0 00-.82-.58 1 1 0 00-.91.42 1 1 0 00-.09 1l5 11H29a4 4 0 00-4 4v61.35a4 4 0 004 4h40.63a4 4 0 004-4V54.65a1.14 1.14 0 000-.52zM27 20.42a2 2 0 012-2h14.58l2.84 6.17a4.92 4.92 0 101.81-.84l-2.45-5.33h23.85a2 2 0 012 2v31.51L59 39.33a1 1 0 00-.71-.29 1 1 0 00-.7.29L51.9 45 40.2 33.34a1 1 0 00-1.42 0L27 45.12zm23.22 7.67l-1.12-2.45h.21a2.89 2.89 0 11-2 .84l1.09 2.44a1 1 0 00.91.58 1 1 0 00.42-.09 1 1 0 00.49-1.32zm21.41 53.67a2 2 0 01-.58 1.42 2 2 0 01-1.42.59H29a2 2 0 01-2-2V48l12.49-12.54 16.78 16.78a1 1 0 101.42-1.42l-4.37-4.36 5-5 13.31 13.3z"/><path class="cls-1" d="M50.11 72.23h1v7.36h-1zM42.88 57.35l-3.16 9.34h1.94l.67-2H46l.68 2h2l-3.17-9.34zm0 5.65l1.26-3.83h.07L45.45 63zM62.06 72.23h3v7.36h-3zM53.99 72.23h1v7.36h-1zM56.94 61.4a3.86 3.86 0 00-1-.25l-2.15-.25a2.55 2.55 0 01-.61-.13.42.42 0 01-.24-.25 2.32 2.32 0 010-.59 1.87 1.87 0 010-.53.53.53 0 01.27-.28 4 4 0 011.62-.21 19.41 19.41 0 012.64.18v-1.57a14.38 14.38 0 00-3-.28 8 8 0 00-1.88.19 2 2 0 00-1.17.81 3.11 3.11 0 00-.42 1.81 4.54 4.54 0 00.19 1.37 1.7 1.7 0 00.67.89 3.24 3.24 0 001.38.47l2 .23a1.64 1.64 0 01.54.13.46.46 0 01.22.27 2.32 2.32 0 010 .59 2.44 2.44 0 010 .54.64.64 0 01-.23.33 1.2 1.2 0 01-.58.21 6.34 6.34 0 01-1.07.06c-.79 0-1.74-.06-2.85-.16v1.61a23 23 0 003.42.22 6.74 6.74 0 001.79-.2 1.84 1.84 0 001.1-.85 3.73 3.73 0 00.4-1.94 3.84 3.84 0 00-.32-1.8 1.46 1.46 0 00-.72-.62z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skipass') }}
								</span>
							</a>
						</li>
						<li class="booking-menu__item" v-if="useRouterLink()">
							<router-link
								:to="{ name: 'skischool' }"
								@click.native="closeBookingMenu"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skischool.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skischool.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.64 22a.45.45 0 00.25.07.5.5 0 00.26-.93 9.16 9.16 0 00-5.82-1 .49.49 0 00-.45.54.48.48 0 00.54.45 8.19 8.19 0 015.22.87z"/><path class="cls-1" d="M83.41 83a1 1 0 00-1.4.17c-2.6 3.33-7.17 3.43-10.32 2.11l-16.26-6.9a5.38 5.38 0 001.42-3.08 3.23 3.23 0 00-1.25-2.46 3.81 3.81 0 01-1-1.26c-.34-.81.56-2.29 1.05-2.88 3.15-3.82 5-7.06 3.85-10.45s-4-5-9.24-7.58C48.9 50 48 49 48 48.18a4.73 4.73 0 011.66-2.25l2.58 1.47a7.22 7.22 0 003.35 4.6 36.54 36.54 0 0012.08 4.45 9.44 9.44 0 003.66.84 4.54 4.54 0 003.4-1.3 3.22 3.22 0 00.59-3.68 3.94 3.94 0 00-2.18-1.91 2 2 0 00-.71-1.59c-1.07-.88-2.9-.67-4.92.55-2.29-1.11-5.32-2.51-6.71-3.15a33.86 33.86 0 00.53-9.48 2.88 2.88 0 00.36-.61 3 3 0 00.16-1.82 8.61 8.61 0 001.64.16 7.75 7.75 0 007.74-7.75v-.36a1.1 1.1 0 00.35-.11 1 1 0 00.48-.74 7 7 0 00-1.56-5.68c-1.57-1.78-4.19-2.76-7.37-2.76-4.81 0-8.31 3.91-8.31 9.31a5.64 5.64 0 00.08.93 54.88 54.88 0 01-3.47-4.93c-2.62-4.11-6.21-5.84-11-5.31a1 1 0 10.23 2c4-.45 6.81.9 9 4.39 3.53 5.52 5.77 8 9.24 10.14.9.56 1.1 1.28.9 1.75a1 1 0 01-1.3.45c-2.14-.57-6-4.35-8.49-8.25-3.43-5.42-7.88-5.49-9.63-5.26a1 1 0 10.25 2c2.91-.38 5.71 1.21 7.69 4.35l.28.42A21.4 21.4 0 0039 32.1l-6.79-6.45 1.87-2a1 1 0 00-1.48-1.35l-1.84 2-2.34-2.23A1 1 0 1027 23.5l2.37 2.25-2 2.21a1 1 0 00.74 1.67 1 1 0 00.74-.32l2-2.18 6.48 6.16a20.17 20.17 0 00-2.19 2.07l-9.9-5.63 1.32-2.44a1 1 0 00-1.76-.95l-1.3 2.4-2.82-1.6a1 1 0 00-1.36.37 1 1 0 00.38 1.37l2.84 1.62-1.42 2.62a1 1 0 00.4 1.36 1.07 1.07 0 00.48.12 1 1 0 00.88-.52l1.4-2.59 9.55 5.43-.24.31A19.75 19.75 0 0030.22 46a1 1 0 00.24.75 1 1 0 00.7.35l1.77.11c-.2 3.42.87 6.54 2.88 8.14 2.72 2.17 7.33 4.12 10.55 5.4A2.09 2.09 0 0147.71 62a3.36 3.36 0 01-.54 2.63c-.76 1.23-4.17 5.26-6.17 7.65l-.86-.36-27.75-11.73a1 1 0 10-.78 1.81c.56.23 55.78 23.58 59.31 25a12.35 12.35 0 004.73.94 9.79 9.79 0 007.93-3.66 1 1 0 00-.17-1.28zM52.06 45l-.64-.37c.23-.13.46-.27.71-.4-.03.26-.05.52-.07.77zm18 7c2-.08 3.09.58 3.44 1.27a1.23 1.23 0 01-.25 1.42c-.61.64-2 1-4.1.28zM58.85 29.22a2.71 2.71 0 01-2.05-2.82c0-4.31 2.6-7.31 6.31-7.31 2.6 0 4.68.74 5.87 2.09a4.59 4.59 0 011.13 2.94.88.88 0 00-.28 0 19.34 19.34 0 00-2.52-.2c-3.11 0-6.25 1.54-6.59 5a3.46 3.46 0 01-1.87.3zm1 2a6.47 6.47 0 002.41-.84 1 1 0 00.46-.85c0-3.5 4.15-3.6 4.62-3.6a18 18 0 011.88.13 5.17 5.17 0 010 .68 5.76 5.76 0 01-5.74 5.75 5.36 5.36 0 01-3.66-1.27zM50 31c2.41 3.13 5.59 6.14 8 6.79a3.51 3.51 0 001 .13 2.86 2.86 0 00.42 0 33.45 33.45 0 01-.73 8.74 1 1 0 00.55 1.15c.07 0 6 2.74 8.78 4.14l-.77 2.51a34.8 34.8 0 01-10.58-4c-1.9-1.21-4.1-3.57-1.35-10.08a1 1 0 10-1.84-.77 19.67 19.67 0 00-.84 2.35 13 13 0 00-3.16 1.69L36.9 36.38C40.21 32.92 44.2 31.3 50 31zM32.38 45.19a17.13 17.13 0 012.78-6.76c.13-.18.27-.34.4-.51l12.29 7A7.59 7.59 0 0046.29 47c-1.48-.31-4.54-.91-7.6-1.25-2.54-.29-4.96-.47-6.31-.56zM47.1 58.91c-2-.78-7.24-2.87-10-5.1-1.16-.93-2.34-3.14-2.13-6.42 1.07.09 2.29.21 3.53.35 3.13.35 6.32 1 7.66 1.27a5.85 5.85 0 003.31 3.46c4.88 2.38 7.27 3.65 8.23 6.44.82 2.38-.54 4.85-3.08 8l-5.4-1.73a5.08 5.08 0 00.44-3.75 4.06 4.06 0 00-2.56-2.52zm6.39 18.65L42.93 73.1c1.31-1.54 3.72-4.41 5.09-6.21l5.33 1.72a4.39 4.39 0 00-.54 3.75 5.66 5.66 0 001.39 1.9c.48.48.65.66.65 1a4.72 4.72 0 01-1.36 2.3z"/><path class="cls-1" d="M66.07 28.77a.88.88 0 00.12.21.7.7 0 00.15.19 1.24 1.24 0 001.77 0 1 1 0 00.16-.19 1.39 1.39 0 00.11-.21 1.09 1.09 0 00.07-.24 1 1 0 000-.48 1.09 1.09 0 00-.07-.24 1.39 1.39 0 00-.11-.21 1.56 1.56 0 00-.16-.2l-.19-.15a.91.91 0 00-.22-.11.9.9 0 00-.23-.08 1.35 1.35 0 00-.49 0 .9.9 0 00-.23.08.91.91 0 00-.22.11l-.19.15a1 1 0 00-.15.2.88.88 0 00-.12.21 2.17 2.17 0 00-.07.24 1.45 1.45 0 000 .48 2.17 2.17 0 00.07.24z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skischool') }}
								</span>
							</router-link>
						</li>
						<li class="booking-menu__item" v-else>
							<a
								:href="
									isEn() + `/${$t('routes.book')}/${$t('routes.skiSchool')}`
								"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skischool.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skischool.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.64 22a.45.45 0 00.25.07.5.5 0 00.26-.93 9.16 9.16 0 00-5.82-1 .49.49 0 00-.45.54.48.48 0 00.54.45 8.19 8.19 0 015.22.87z"/><path class="cls-1" d="M83.41 83a1 1 0 00-1.4.17c-2.6 3.33-7.17 3.43-10.32 2.11l-16.26-6.9a5.38 5.38 0 001.42-3.08 3.23 3.23 0 00-1.25-2.46 3.81 3.81 0 01-1-1.26c-.34-.81.56-2.29 1.05-2.88 3.15-3.82 5-7.06 3.85-10.45s-4-5-9.24-7.58C48.9 50 48 49 48 48.18a4.73 4.73 0 011.66-2.25l2.58 1.47a7.22 7.22 0 003.35 4.6 36.54 36.54 0 0012.08 4.45 9.44 9.44 0 003.66.84 4.54 4.54 0 003.4-1.3 3.22 3.22 0 00.59-3.68 3.94 3.94 0 00-2.18-1.91 2 2 0 00-.71-1.59c-1.07-.88-2.9-.67-4.92.55-2.29-1.11-5.32-2.51-6.71-3.15a33.86 33.86 0 00.53-9.48 2.88 2.88 0 00.36-.61 3 3 0 00.16-1.82 8.61 8.61 0 001.64.16 7.75 7.75 0 007.74-7.75v-.36a1.1 1.1 0 00.35-.11 1 1 0 00.48-.74 7 7 0 00-1.56-5.68c-1.57-1.78-4.19-2.76-7.37-2.76-4.81 0-8.31 3.91-8.31 9.31a5.64 5.64 0 00.08.93 54.88 54.88 0 01-3.47-4.93c-2.62-4.11-6.21-5.84-11-5.31a1 1 0 10.23 2c4-.45 6.81.9 9 4.39 3.53 5.52 5.77 8 9.24 10.14.9.56 1.1 1.28.9 1.75a1 1 0 01-1.3.45c-2.14-.57-6-4.35-8.49-8.25-3.43-5.42-7.88-5.49-9.63-5.26a1 1 0 10.25 2c2.91-.38 5.71 1.21 7.69 4.35l.28.42A21.4 21.4 0 0039 32.1l-6.79-6.45 1.87-2a1 1 0 00-1.48-1.35l-1.84 2-2.34-2.23A1 1 0 1027 23.5l2.37 2.25-2 2.21a1 1 0 00.74 1.67 1 1 0 00.74-.32l2-2.18 6.48 6.16a20.17 20.17 0 00-2.19 2.07l-9.9-5.63 1.32-2.44a1 1 0 00-1.76-.95l-1.3 2.4-2.82-1.6a1 1 0 00-1.36.37 1 1 0 00.38 1.37l2.84 1.62-1.42 2.62a1 1 0 00.4 1.36 1.07 1.07 0 00.48.12 1 1 0 00.88-.52l1.4-2.59 9.55 5.43-.24.31A19.75 19.75 0 0030.22 46a1 1 0 00.24.75 1 1 0 00.7.35l1.77.11c-.2 3.42.87 6.54 2.88 8.14 2.72 2.17 7.33 4.12 10.55 5.4A2.09 2.09 0 0147.71 62a3.36 3.36 0 01-.54 2.63c-.76 1.23-4.17 5.26-6.17 7.65l-.86-.36-27.75-11.73a1 1 0 10-.78 1.81c.56.23 55.78 23.58 59.31 25a12.35 12.35 0 004.73.94 9.79 9.79 0 007.93-3.66 1 1 0 00-.17-1.28zM52.06 45l-.64-.37c.23-.13.46-.27.71-.4-.03.26-.05.52-.07.77zm18 7c2-.08 3.09.58 3.44 1.27a1.23 1.23 0 01-.25 1.42c-.61.64-2 1-4.1.28zM58.85 29.22a2.71 2.71 0 01-2.05-2.82c0-4.31 2.6-7.31 6.31-7.31 2.6 0 4.68.74 5.87 2.09a4.59 4.59 0 011.13 2.94.88.88 0 00-.28 0 19.34 19.34 0 00-2.52-.2c-3.11 0-6.25 1.54-6.59 5a3.46 3.46 0 01-1.87.3zm1 2a6.47 6.47 0 002.41-.84 1 1 0 00.46-.85c0-3.5 4.15-3.6 4.62-3.6a18 18 0 011.88.13 5.17 5.17 0 010 .68 5.76 5.76 0 01-5.74 5.75 5.36 5.36 0 01-3.66-1.27zM50 31c2.41 3.13 5.59 6.14 8 6.79a3.51 3.51 0 001 .13 2.86 2.86 0 00.42 0 33.45 33.45 0 01-.73 8.74 1 1 0 00.55 1.15c.07 0 6 2.74 8.78 4.14l-.77 2.51a34.8 34.8 0 01-10.58-4c-1.9-1.21-4.1-3.57-1.35-10.08a1 1 0 10-1.84-.77 19.67 19.67 0 00-.84 2.35 13 13 0 00-3.16 1.69L36.9 36.38C40.21 32.92 44.2 31.3 50 31zM32.38 45.19a17.13 17.13 0 012.78-6.76c.13-.18.27-.34.4-.51l12.29 7A7.59 7.59 0 0046.29 47c-1.48-.31-4.54-.91-7.6-1.25-2.54-.29-4.96-.47-6.31-.56zM47.1 58.91c-2-.78-7.24-2.87-10-5.1-1.16-.93-2.34-3.14-2.13-6.42 1.07.09 2.29.21 3.53.35 3.13.35 6.32 1 7.66 1.27a5.85 5.85 0 003.31 3.46c4.88 2.38 7.27 3.65 8.23 6.44.82 2.38-.54 4.85-3.08 8l-5.4-1.73a5.08 5.08 0 00.44-3.75 4.06 4.06 0 00-2.56-2.52zm6.39 18.65L42.93 73.1c1.31-1.54 3.72-4.41 5.09-6.21l5.33 1.72a4.39 4.39 0 00-.54 3.75 5.66 5.66 0 001.39 1.9c.48.48.65.66.65 1a4.72 4.72 0 01-1.36 2.3z"/><path class="cls-1" d="M66.07 28.77a.88.88 0 00.12.21.7.7 0 00.15.19 1.24 1.24 0 001.77 0 1 1 0 00.16-.19 1.39 1.39 0 00.11-.21 1.09 1.09 0 00.07-.24 1 1 0 000-.48 1.09 1.09 0 00-.07-.24 1.39 1.39 0 00-.11-.21 1.56 1.56 0 00-.16-.2l-.19-.15a.91.91 0 00-.22-.11.9.9 0 00-.23-.08 1.35 1.35 0 00-.49 0 .9.9 0 00-.23.08.91.91 0 00-.22.11l-.19.15a1 1 0 00-.15.2.88.88 0 00-.12.21 2.17 2.17 0 00-.07.24 1.45 1.45 0 000 .48 2.17 2.17 0 00.07.24z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skischool') }}
								</span>
							</a>
						</li>
						<li class="booking-menu__item" v-if="useRouterLink()">
							<router-link
								:to="{ name: 'skirental' }"
								@click.native="closeBookingMenu"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skirental.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skirental.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M80 77.11a1 1 0 00-.73-.28h-.91v-4.56c0-2.23-1.15-3.75-3.61-4.8a34.35 34.35 0 01-4-2.39C68.62 63.69 66 62 62.52 60l-.81-.45a1 1 0 000-.72 5.58 5.58 0 00-2.29-2.47c-1.87-1.32-3.06-1-3.28-.94a1.06 1.06 0 00-.33.18l-.08.08-.12-.1a.7.7 0 00.08-.2 4.78 4.78 0 00-.64-2.66c-.75-1.49-1.42-1.9-1.76-2a4.27 4.27 0 002.66-2h.26a1 1 0 00.68-.28A4.42 4.42 0 0058 46.17a5.05 5.05 0 00.11-2.32 1 1 0 00-.6-.68l.75-3.61h.12a1 1 0 00.54-.16c.41-.26 1-1 1.27-3a5.64 5.64 0 000-2.94 1 1 0 00-.58-.54c.38-1.94.64-3.29.64-3.29a.9.9 0 000-.4l3-9.73-1.06-.23a23.21 23.21 0 00-8.06 0 10 10 0 00-6 3.29 37.82 37.82 0 01-3.8-3.69 12.52 12.52 0 00-6.17-3.7l-.74-.17-.36.67a35.48 35.48 0 00-2.13 4.85 20.75 20.75 0 00-.82 4.42 6.64 6.64 0 00-2.11-.41h-.88l-.12.89s-.65 6-1.54 14.31c-.69 6.52-1.46 8.64-2.58 11.56-.29.76-.6 1.58-.93 2.54C24.34 58.51 23.1 64 23.09 64l-.09.45.23.36s.3.45.71 1A9.73 9.73 0 0024 71a12.81 12.81 0 001 2.53 1 1 0 00-.93 1v5.3c0 .1.53 2.33 4 2.33H40a1 1 0 00.35-.06 26.72 26.72 0 018.38-1.1 87.66 87.66 0 0110.1 1 90.38 90.38 0 0010.77 1 30.55 30.55 0 0010-1.44 1 1 0 00.65-.94v-2.79a1 1 0 00-.25-.72zM61.54 61.77c2.94 1.65 5.29 3.14 7.22 4.41-.89 1-2 1.32-3.86 1.21a65.62 65.62 0 01-7.82-1.93c.16-.25.32-.49.47-.7 1.12-1.56 2.13-2.79 2.85-3.63zm-4.63-4.4a3.48 3.48 0 011.4.66 6.5 6.5 0 011.22 1 54 54 0 00-3.6 4.52 73.18 73.18 0 00-5.3 9.92L49.37 73a46.51 46.51 0 013.34-9.74 22.38 22.38 0 014.2-5.89zm-2.83-.49l.3.27a25.37 25.37 0 00-3.46 5.29c-.18.36-.34.72-.51 1.07-1.15-.33-2.21-.64-3.1-.88a6.3 6.3 0 01-2.09-1 71.14 71.14 0 008.86-4.75zm-.78-3.23a4.59 4.59 0 01.4 1.09 66.28 66.28 0 01-11.4 5.92 70.16 70.16 0 01-10.52 3.21l-.31-1.35c1.82-.51 6-1.72 9.53-3.07 4-1.51 9.91-5.21 11.9-6.48a5.77 5.77 0 01.4.68zm-12.42 3.69l-.59.24c-.69.26-1.39.52-2.11.76a8.17 8.17 0 010-3.93 5.53 5.53 0 013.5-3.89c-.28 1.24-.51 2.33-.66 3.16a12.47 12.47 0 00-.14 3.66zm7.07-9a1 1 0 00-1 .21 1 1 0 00-.28 1 1 1 0 00.76.71 15.48 15.48 0 003.88.68 3.26 3.26 0 00.05.67c-1.79 1.12-5.38 3.33-8.53 4.88a10.22 10.22 0 01.11-2.49c.25-1.4.74-3.54 1.31-6l.26-1.13c3 .66 6.62 1.2 9.08 1.53-.88.6-2.46.81-5.59-.08zm8.1-2.56a4.53 4.53 0 01-.32.94h-.32a108.62 108.62 0 01-12.79-2.24c-3.33-1-6.55-2-8-2.45l.23-1.73c1.58.47 4.65 1.36 8.2 2.3A133 133 0 0056.18 45a6.35 6.35 0 01-.13.76zm-.52-2.91c-2.35-.35-6.35-1-9.74-1.75.25-1.19.46-2.25.63-3.23h.23c3.5.62 7.21 1.12 9.61 1.41-.26 1.26-.5 2.47-.73 3.55zm2.69-6.74a7.42 7.42 0 01-.34 1.39h-.31c-1.79-.21-6.4-.78-10.57-1.52s-9.36-1.79-11.44-2.22l.27-1.78c2.22.45 7.63 1.43 11.83 1.88s8.83.8 10.68.94a9.38 9.38 0 01-.12 1.29zM54.4 21.26a23.15 23.15 0 016.22-.18l-2.18 7.13-3.28-.88a31.64 31.64 0 01-5.57-3.51 8 8 0 014.81-2.56zm3.68 9c-.12.62-.3 1.51-.51 2.58-2.18-.17-6.08-.48-9.7-.87-1-.11-2.07-.24-3.15-.4a2 2 0 01.17-1.43 5.48 5.48 0 014.46-2c1.19.08 5.92 1.32 8.73 2.09zm-21.26-9.11a31 31 0 011.63-3.8 10.51 10.51 0 014.28 2.85 41.1 41.1 0 006.5 5.86 7.43 7.43 0 00-6 3 3.71 3.71 0 00-.51 2.16L41.51 31a11.48 11.48 0 00-4.6-4.84l-.86-.43a21.61 21.61 0 01.77-4.58zm-9 33.33c.33-.94.63-1.74.91-2.49 1.15-3.06 2-5.27 2.7-12 .67-6.27 1.2-11.21 1.43-13.27A14.07 14.07 0 0136 27.93a8.64 8.64 0 012.89 2.62c-2.12-.37-3.62-.66-3.66-.67a1 1 0 00-.76.16 1 1 0 00-.42.66l-.59 3.64a1 1 0 00.78 1.14c.06 0 5.32 1.11 10.24 2-.17.94-.37 2-.61 3.13l-.27-.07C38.47 39.22 34.35 38 34.31 38a1 1 0 00-.83.12 1 1 0 00-.45.71l-.49 3.71a1 1 0 00.67 1.08s4.36 1.38 8.86 2.68l.49.13-.26 1.14-.15.67a7.9 7.9 0 00-5.95 5.65 10.06 10.06 0 00.09 5.11C33 60.06 30.07 60.83 30 60.84a1 1 0 00-.69 1.16l.69 3.26a1 1 0 001 .79h.17a61.45 61.45 0 007.06-1.82c.2.46.41.9.58 1.33 1.08 2.54.59 5-1.2 6s-5.06.32-7.37-1.47a31.88 31.88 0 01-5.12-6c.34-1.38 1.4-5.77 2.72-9.61zM69.6 81a90.44 90.44 0 01-10.52-1 87.57 87.57 0 00-10.35-1 29.4 29.4 0 00-8.9 1.13H28c-1.49 0-1.9-.55-2-.7v-3.9h.9a1 1 0 00.93-.66 1 1 0 00-.3-1.11 7.2 7.2 0 01-1.61-3.3 8.1 8.1 0 01-.29-2.35A21.48 21.48 0 0029 71.68a11.38 11.38 0 006.57 2.37 6.06 6.06 0 003-.76c2.65-1.57 3.48-5.08 2-8.53-.16-.38-.34-.78-.53-1.18.92-.32 1.88-.67 2.88-1.06l.15-.06a7.75 7.75 0 003.6 2.1l2.85.81a49.38 49.38 0 00-2.4 8.17 1 1 0 00.64 1.12l3 1a1 1 0 00.34.06 1 1 0 00.91-.59 88.62 88.62 0 014-8 59 59 0 008.75 2.16h.74a5.93 5.93 0 005-2.13 24.86 24.86 0 003.46 2c2.1.89 2.39 2 2.39 3v5.68a46.65 46.65 0 01-6.88.61 75.15 75.15 0 01-9.23-.81 79.48 79.48 0 00-16.81-.85.52.52 0 00-.46.54.49.49 0 00.17.34.52.52 0 00.37.12 78.16 78.16 0 0116.6.84 75.31 75.31 0 009.36.82 48.35 48.35 0 007.78-.75h1v1.12A31.79 31.79 0 0169.6 81z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skirental') }}
								</span>
							</router-link>
						</li>
						<li class="booking-menu__item" v-else @click="closeBookingMenu">
							<a
								:href="
									isEn() + `/${$t('routes.book')}/${$t('routes.equipment')}`
								"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.skirental.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.skirental.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M80 77.11a1 1 0 00-.73-.28h-.91v-4.56c0-2.23-1.15-3.75-3.61-4.8a34.35 34.35 0 01-4-2.39C68.62 63.69 66 62 62.52 60l-.81-.45a1 1 0 000-.72 5.58 5.58 0 00-2.29-2.47c-1.87-1.32-3.06-1-3.28-.94a1.06 1.06 0 00-.33.18l-.08.08-.12-.1a.7.7 0 00.08-.2 4.78 4.78 0 00-.64-2.66c-.75-1.49-1.42-1.9-1.76-2a4.27 4.27 0 002.66-2h.26a1 1 0 00.68-.28A4.42 4.42 0 0058 46.17a5.05 5.05 0 00.11-2.32 1 1 0 00-.6-.68l.75-3.61h.12a1 1 0 00.54-.16c.41-.26 1-1 1.27-3a5.64 5.64 0 000-2.94 1 1 0 00-.58-.54c.38-1.94.64-3.29.64-3.29a.9.9 0 000-.4l3-9.73-1.06-.23a23.21 23.21 0 00-8.06 0 10 10 0 00-6 3.29 37.82 37.82 0 01-3.8-3.69 12.52 12.52 0 00-6.17-3.7l-.74-.17-.36.67a35.48 35.48 0 00-2.13 4.85 20.75 20.75 0 00-.82 4.42 6.64 6.64 0 00-2.11-.41h-.88l-.12.89s-.65 6-1.54 14.31c-.69 6.52-1.46 8.64-2.58 11.56-.29.76-.6 1.58-.93 2.54C24.34 58.51 23.1 64 23.09 64l-.09.45.23.36s.3.45.71 1A9.73 9.73 0 0024 71a12.81 12.81 0 001 2.53 1 1 0 00-.93 1v5.3c0 .1.53 2.33 4 2.33H40a1 1 0 00.35-.06 26.72 26.72 0 018.38-1.1 87.66 87.66 0 0110.1 1 90.38 90.38 0 0010.77 1 30.55 30.55 0 0010-1.44 1 1 0 00.65-.94v-2.79a1 1 0 00-.25-.72zM61.54 61.77c2.94 1.65 5.29 3.14 7.22 4.41-.89 1-2 1.32-3.86 1.21a65.62 65.62 0 01-7.82-1.93c.16-.25.32-.49.47-.7 1.12-1.56 2.13-2.79 2.85-3.63zm-4.63-4.4a3.48 3.48 0 011.4.66 6.5 6.5 0 011.22 1 54 54 0 00-3.6 4.52 73.18 73.18 0 00-5.3 9.92L49.37 73a46.51 46.51 0 013.34-9.74 22.38 22.38 0 014.2-5.89zm-2.83-.49l.3.27a25.37 25.37 0 00-3.46 5.29c-.18.36-.34.72-.51 1.07-1.15-.33-2.21-.64-3.1-.88a6.3 6.3 0 01-2.09-1 71.14 71.14 0 008.86-4.75zm-.78-3.23a4.59 4.59 0 01.4 1.09 66.28 66.28 0 01-11.4 5.92 70.16 70.16 0 01-10.52 3.21l-.31-1.35c1.82-.51 6-1.72 9.53-3.07 4-1.51 9.91-5.21 11.9-6.48a5.77 5.77 0 01.4.68zm-12.42 3.69l-.59.24c-.69.26-1.39.52-2.11.76a8.17 8.17 0 010-3.93 5.53 5.53 0 013.5-3.89c-.28 1.24-.51 2.33-.66 3.16a12.47 12.47 0 00-.14 3.66zm7.07-9a1 1 0 00-1 .21 1 1 0 00-.28 1 1 1 0 00.76.71 15.48 15.48 0 003.88.68 3.26 3.26 0 00.05.67c-1.79 1.12-5.38 3.33-8.53 4.88a10.22 10.22 0 01.11-2.49c.25-1.4.74-3.54 1.31-6l.26-1.13c3 .66 6.62 1.2 9.08 1.53-.88.6-2.46.81-5.59-.08zm8.1-2.56a4.53 4.53 0 01-.32.94h-.32a108.62 108.62 0 01-12.79-2.24c-3.33-1-6.55-2-8-2.45l.23-1.73c1.58.47 4.65 1.36 8.2 2.3A133 133 0 0056.18 45a6.35 6.35 0 01-.13.76zm-.52-2.91c-2.35-.35-6.35-1-9.74-1.75.25-1.19.46-2.25.63-3.23h.23c3.5.62 7.21 1.12 9.61 1.41-.26 1.26-.5 2.47-.73 3.55zm2.69-6.74a7.42 7.42 0 01-.34 1.39h-.31c-1.79-.21-6.4-.78-10.57-1.52s-9.36-1.79-11.44-2.22l.27-1.78c2.22.45 7.63 1.43 11.83 1.88s8.83.8 10.68.94a9.38 9.38 0 01-.12 1.29zM54.4 21.26a23.15 23.15 0 016.22-.18l-2.18 7.13-3.28-.88a31.64 31.64 0 01-5.57-3.51 8 8 0 014.81-2.56zm3.68 9c-.12.62-.3 1.51-.51 2.58-2.18-.17-6.08-.48-9.7-.87-1-.11-2.07-.24-3.15-.4a2 2 0 01.17-1.43 5.48 5.48 0 014.46-2c1.19.08 5.92 1.32 8.73 2.09zm-21.26-9.11a31 31 0 011.63-3.8 10.51 10.51 0 014.28 2.85 41.1 41.1 0 006.5 5.86 7.43 7.43 0 00-6 3 3.71 3.71 0 00-.51 2.16L41.51 31a11.48 11.48 0 00-4.6-4.84l-.86-.43a21.61 21.61 0 01.77-4.58zm-9 33.33c.33-.94.63-1.74.91-2.49 1.15-3.06 2-5.27 2.7-12 .67-6.27 1.2-11.21 1.43-13.27A14.07 14.07 0 0136 27.93a8.64 8.64 0 012.89 2.62c-2.12-.37-3.62-.66-3.66-.67a1 1 0 00-.76.16 1 1 0 00-.42.66l-.59 3.64a1 1 0 00.78 1.14c.06 0 5.32 1.11 10.24 2-.17.94-.37 2-.61 3.13l-.27-.07C38.47 39.22 34.35 38 34.31 38a1 1 0 00-.83.12 1 1 0 00-.45.71l-.49 3.71a1 1 0 00.67 1.08s4.36 1.38 8.86 2.68l.49.13-.26 1.14-.15.67a7.9 7.9 0 00-5.95 5.65 10.06 10.06 0 00.09 5.11C33 60.06 30.07 60.83 30 60.84a1 1 0 00-.69 1.16l.69 3.26a1 1 0 001 .79h.17a61.45 61.45 0 007.06-1.82c.2.46.41.9.58 1.33 1.08 2.54.59 5-1.2 6s-5.06.32-7.37-1.47a31.88 31.88 0 01-5.12-6c.34-1.38 1.4-5.77 2.72-9.61zM69.6 81a90.44 90.44 0 01-10.52-1 87.57 87.57 0 00-10.35-1 29.4 29.4 0 00-8.9 1.13H28c-1.49 0-1.9-.55-2-.7v-3.9h.9a1 1 0 00.93-.66 1 1 0 00-.3-1.11 7.2 7.2 0 01-1.61-3.3 8.1 8.1 0 01-.29-2.35A21.48 21.48 0 0029 71.68a11.38 11.38 0 006.57 2.37 6.06 6.06 0 003-.76c2.65-1.57 3.48-5.08 2-8.53-.16-.38-.34-.78-.53-1.18.92-.32 1.88-.67 2.88-1.06l.15-.06a7.75 7.75 0 003.6 2.1l2.85.81a49.38 49.38 0 00-2.4 8.17 1 1 0 00.64 1.12l3 1a1 1 0 00.34.06 1 1 0 00.91-.59 88.62 88.62 0 014-8 59 59 0 008.75 2.16h.74a5.93 5.93 0 005-2.13 24.86 24.86 0 003.46 2c2.1.89 2.39 2 2.39 3v5.68a46.65 46.65 0 01-6.88.61 75.15 75.15 0 01-9.23-.81 79.48 79.48 0 00-16.81-.85.52.52 0 00-.46.54.49.49 0 00.17.34.52.52 0 00.37.12 78.16 78.16 0 0116.6.84 75.31 75.31 0 009.36.82 48.35 48.35 0 007.78-.75h1v1.12A31.79 31.79 0 0169.6 81z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.skirental') }}
								</span>
							</a>
						</li>

						<li class="booking-menu__item" v-if="useRouterLink()">
							<router-link
								:to="{ name: 'activities' }"
								@click.native="closeBookingMenu"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.activities.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.activities.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M22.46 21a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm-6.86 4.39l3.47 2a1 1 0 01.36 1.37 1 1 0 01-1.36.36l-3.47-2a1 1 0 011-1.73zm15.09.37a1 1 0 01-.37 1.36l-3.46 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.46-2a1 1 0 011.37.37zM53 27.52a1 1 0 011.4-.18l2.6 2a1 1 0 01-.61 1.79 1 1 0 01-.6-.2l-2.61-2a1 1 0 01-.18-1.41zm-26.14 4.37l3.46 2a1 1 0 01-.5 1.87 1 1 0 01-.5-.14l-3.46-2a1 1 0 111-1.73zm-7.43.37a1 1 0 01-.36 1.36l-3.47 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.47-2a1 1 0 011.36.37zm40.08.24a1 1 0 011.41-.18l2.6 2a1 1 0 01.18 1.4 1 1 0 01-.79.39 1 1 0 01-.61-.2l-2.6-2a1 1 0 01-.19-1.41zM22.46 34a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm26 5.49l-.91 2.78a1 1 0 01-1 .69H43.7l2.36 1.72a1 1 0 01.37 1.12l-.91 2.78 2.37-1.72a1 1 0 01.59-.19 1 1 0 01.59.19l2.36 1.72-.9-2.78a1 1 0 01.36-1.12L53.26 43h-2.93a1 1 0 01-.95-.69zm0-4.24a1 1 0 011 .69l1.63 5h5.28a1 1 0 01.58 1.81l-4.26 3.1 1.63 5a1 1 0 01-.4 1.15 1 1 0 01-1.17 0l-4.27-3.11L44.21 52A1 1 0 0143 52a1 1 0 01-.36-1.12l1.63-5-4.27-3.1a1 1 0 01-.36-1.12 1 1 0 01.95-.69h5.31l1.63-5a1 1 0 01.95-.71zm29.08 25.22a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zM53.31 15.6l-5.26 6.87 2.46 1.88a1 1 0 01.18 1.4 1 1 0 01-.79.4 1 1 0 01-.61-.21l-2.46-1.88-21.19 27.68 6.29 4.81a5.92 5.92 0 019.26 7.09l6.28 4.81 21.19-27.68-2.45-1.88a1 1 0 01-.21-1.41 1 1 0 011.4-.18l2.46 1.88 5.26-6.87-6.27-4.81a5.91 5.91 0 01-7.62.36 5.94 5.94 0 01-1.64-7.45zm17.37 49.26l3.46 2a1 1 0 01.37 1.36 1 1 0 01-.87.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm15.09.36a1 1 0 01-.37 1.37l-3.47 2a1 1 0 01-1.36-.37 1 1 0 01.36-1.36l3.47-2a1 1 0 011.37.36zm-3.83 6.14l3.46 2a1 1 0 01.36 1.36 1 1 0 01-.86.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm-7.43.36a1 1 0 01-.37 1.37l-3.46 2a1 1 0 01-.5.13 1 1 0 01-.5-1.86l3.46-2a1 1 0 011.37.36zm3 1.75a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011.03-1zm-9.2-28.95L48.46 70.46a1.05 1.05 0 01-.67.39h-.13a1 1 0 01-.61-.2l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 00-.73-5.49 3.92 3.92 0 00-5.49.73 1 1 0 01-1.4.19l-.51-.39-7.2 9.41L30 72.53a5.92 5.92 0 019.26 7.09l6.28 4.81 21.21-27.69-2.46-1.88a1 1 0 01-.18-1.4 1 1 0 011.4-.19L68 55.15l5.25-6.86zM53 13.21a1 1 0 01.74.2l7.8 6a1 1 0 01.19 1.4A3.91 3.91 0 0065.34 27a3.92 3.92 0 002.6-1.5 1 1 0 01.66-.38 1 1 0 01.74.2l7.81 6a1 1 0 01.18 1.4l-6.47 8.46-1.34 1.74 5.71 4.38a1 1 0 01.19 1.4L69 57.16 46.54 86.44a1 1 0 01-.66.38h-.13a1 1 0 01-.61-.21l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 10-6.22-4.76 1 1 0 01-1.4.18l-7.81-6a1 1 0 01-.18-1.4l7.81-10.2-5.71-4.38a1 1 0 01-.19-1.4l28.88-37.66a1 1 0 01.67-.38z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.activities') }}
								</span>
							</router-link>
						</li>
						<li class="booking-menu__item" v-else>
							<a
								:href="
									isEn() + `/${$t('routes.book')}/${$t('routes.activities')}`
								"
							>
								<span
									class="booking-menu__uncheck"
									v-if="this.$store.state.cart.activities.length == 0"
								></span>
								<span
									class="booking-menu__check"
									v-if="this.$store.state.cart.activities.length > 0"
								>
									<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M5.43 11a1 1 0 01-.76-.35l-3.43-4a1 1 0 011.52-1.3l2.5 2.92L9.13 1.5a1 1 0 111.74 1l-4.57 8a1 1 0 01-.78.5h-.09" fill="#fff" fill-rule="evenodd"/></svg>
								</span>
								<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:class="'booking-menu__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M22.46 21a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm-6.86 4.39l3.47 2a1 1 0 01.36 1.37 1 1 0 01-1.36.36l-3.47-2a1 1 0 011-1.73zm15.09.37a1 1 0 01-.37 1.36l-3.46 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.46-2a1 1 0 011.37.37zM53 27.52a1 1 0 011.4-.18l2.6 2a1 1 0 01-.61 1.79 1 1 0 01-.6-.2l-2.61-2a1 1 0 01-.18-1.41zm-26.14 4.37l3.46 2a1 1 0 01-.5 1.87 1 1 0 01-.5-.14l-3.46-2a1 1 0 111-1.73zm-7.43.37a1 1 0 01-.36 1.36l-3.47 2a1 1 0 01-.5.14 1 1 0 01-.5-1.87l3.47-2a1 1 0 011.36.37zm40.08.24a1 1 0 011.41-.18l2.6 2a1 1 0 01.18 1.4 1 1 0 01-.79.39 1 1 0 01-.61-.2l-2.6-2a1 1 0 01-.19-1.41zM22.46 34a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm26 5.49l-.91 2.78a1 1 0 01-1 .69H43.7l2.36 1.72a1 1 0 01.37 1.12l-.91 2.78 2.37-1.72a1 1 0 01.59-.19 1 1 0 01.59.19l2.36 1.72-.9-2.78a1 1 0 01.36-1.12L53.26 43h-2.93a1 1 0 01-.95-.69zm0-4.24a1 1 0 011 .69l1.63 5h5.28a1 1 0 01.58 1.81l-4.26 3.1 1.63 5a1 1 0 01-.4 1.15 1 1 0 01-1.17 0l-4.27-3.11L44.21 52A1 1 0 0143 52a1 1 0 01-.36-1.12l1.63-5-4.27-3.1a1 1 0 01-.36-1.12 1 1 0 01.95-.69h5.31l1.63-5a1 1 0 01.95-.71zm29.08 25.22a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zM53.31 15.6l-5.26 6.87 2.46 1.88a1 1 0 01.18 1.4 1 1 0 01-.79.4 1 1 0 01-.61-.21l-2.46-1.88-21.19 27.68 6.29 4.81a5.92 5.92 0 019.26 7.09l6.28 4.81 21.19-27.68-2.45-1.88a1 1 0 01-.21-1.41 1 1 0 011.4-.18l2.46 1.88 5.26-6.87-6.27-4.81a5.91 5.91 0 01-7.62.36 5.94 5.94 0 01-1.64-7.45zm17.37 49.26l3.46 2a1 1 0 01.37 1.36 1 1 0 01-.87.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm15.09.36a1 1 0 01-.37 1.37l-3.47 2a1 1 0 01-1.36-.37 1 1 0 01.36-1.36l3.47-2a1 1 0 011.37.36zm-3.83 6.14l3.46 2a1 1 0 01.36 1.36 1 1 0 01-.86.5 1 1 0 01-.5-.13l-3.46-2a1 1 0 111-1.73zm-7.43.36a1 1 0 01-.37 1.37l-3.46 2a1 1 0 01-.5.13 1 1 0 01-.5-1.86l3.46-2a1 1 0 011.37.36zm3 1.75a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011.03-1zm-9.2-28.95L48.46 70.46a1.05 1.05 0 01-.67.39h-.13a1 1 0 01-.61-.2l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 00-.73-5.49 3.92 3.92 0 00-5.49.73 1 1 0 01-1.4.19l-.51-.39-7.2 9.41L30 72.53a5.92 5.92 0 019.26 7.09l6.28 4.81 21.21-27.69-2.46-1.88a1 1 0 01-.18-1.4 1 1 0 011.4-.19L68 55.15l5.25-6.86zM53 13.21a1 1 0 01.74.2l7.8 6a1 1 0 01.19 1.4A3.91 3.91 0 0065.34 27a3.92 3.92 0 002.6-1.5 1 1 0 01.66-.38 1 1 0 01.74.2l7.81 6a1 1 0 01.18 1.4l-6.47 8.46-1.34 1.74 5.71 4.38a1 1 0 01.19 1.4L69 57.16 46.54 86.44a1 1 0 01-.66.38h-.13a1 1 0 01-.61-.21l-7.8-6a1 1 0 01-.19-1.4 3.92 3.92 0 10-6.22-4.76 1 1 0 01-1.4.18l-7.81-6a1 1 0 01-.18-1.4l7.81-10.2-5.71-4.38a1 1 0 01-.19-1.4l28.88-37.66a1 1 0 01.67-.38z"/></svg>
								<span class="booking-menu__label">
									{{ $t('navigation.activities') }}
								</span>
							</a>
						</li>
					</ul>
					<div
						v-if="OutsideClose"
						class="booking-menu__wrapper"
						@click="clickOutside"
					></div>
					<router-link
						:to="{ name: 'cart' }"
						class="booking-menu__button"
						@click.native="closeBookingMenu"
						v-if="useRouterLink()"
					>
						{{ $t('navigation.toCheckout') }}
					</router-link>
					<a
						v-else
						:href="isEn() + `/${$t('routes.book')}/${$t('routes.cart')}`"
						class="booking-menu__button"
					>
						{{ $t('navigation.toCheckout') }}
					</a>
				</div>

				<!-- </div> -->
			</div>
		</div>
	</transition>
</template>

<script>
import store from '../../vueX/store'

export default {
	name: 'BookingMenu',
	props: {
		parentmessage: Boolean,
		show: {
			type: Boolean,
			default: true
		},
		OutsideClose: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			isStatic: false
		}
	},
	methods: {
		isEn() {
			return window.location.href.includes('/en/') ? '/en' : ''
		},
		useRouterLink() {
			return this.$route.name ? true : false
		},
		clickOutside(e) {
			if (e.currentTarget == e.target) {
				this.$emit('close')
			}
		},
		closeBookingMenu() {
			if (this.show) {
				this.$emit('close')
			}
		},
		showBookingMenu: function () {
			this.isActive = true
		}
	},
	store
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.booking-menu__wrapper {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: -1;
}

.booking-menu {
	width: 100%;
	position: absolute;
	top: 58px;
	left: 0;
	z-index: 10;
	background: $colorPrimary8;
	padding: 15px 0;
	visibility: hidden;

	&--active {
		z-index: 100;
		visibility: visible;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	}

	> .grid-container {
		max-width: 1160px;
	}

	&__content {
		display: flex;
		align-items: center;
		z-index: 100;

		flex-wrap: wrap;
		justify-content: center;

		@include for-tablet-portrait-up {
			flex-wrap: nowrap;
			justify-content: space-between;
		}
	}
	ul {
		margin: 0;
		padding: 0;

		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		@include for-tablet-portrait-up {
			display: block;
		}
	}
	li {
		display: inline-block;
		list-style: none;
		position: relative;
		padding: 12px 45px;
		text-align: center;
		@include for-tablet-portrait-up {
			padding: 12px 35px;
		}
		a {
			display: inline-block;
			position: relative;
			text-decoration: none;
			outline: none;
			&:hover {
				svg {
					fill: $colorWhite;
				}
				.booking-menu__label {
					color: $colorWhite;
				}
			}
		}
		.booking-menu__icon {
			height: 65px;
			width: 65px;
			fill: $colorPrimary5;
			margin: 0 3px;
			outline: none;
		}
		.booking-menu__label {
			display: block;
			color: $colorPrimary2;
			font-family: Saira;
			font-size: 14px;
			font-weight: 500;
			letter-spacing: 0;
			line-height: 22px;
			text-align: center;
			&:after {
				content: '';
				display: block;
				width: 42px;
				height: 3px;
				background: transparent;
				margin: 5px auto 0 auto;
			}
		}
		.booking-menu__check,
		.booking-menu__uncheck {
			position: absolute;
			width: 20px;
			height: 20px;
			font-size: 10px;
			font-weight: bold;
			background-color: $colorSecondary;
			border-radius: 100%;
			z-index: 5;
			right: 0px;
			top: 45px;
			padding: 4px;
			box-sizing: border-box;
			svg {
				width: 12px;
				height: 12px;
			}
		}
		.booking-menu__uncheck {
			position: relative;
			background-color: $colorPrimary5;
			top: auto;
			right: auto;
			margin-right: 10px;
			float: left;
			display: none;
		}
		&:after,
		&:nth-child(odd):before {
			content: '';
			width: 1px;
			height: 100px;
			position: absolute;
			top: 10px;
		}

		@include for-tablet-portrait-up {
			&:after,
			&:first-child:before {
				content: '';
				background: $colorPrimary7;
			}
		}

		&:after {
			right: 0;
		}
		&:nth-child(odd):before {
			left: 0;
		}
		@include for-tablet-portrait-up {
			&:first-child:before {
				content: '';
			}
		}

		a.router-link-exact-active {
			.booking-menu__label:after {
				background: #59bdf6;
			}
			svg {
				fill: $colorWhite;
			}
			.booking-menu__label {
				color: $colorWhite;
			}
		}
	}

	&--static {
		box-shadow: none;
		position: relative;
		top: 0;
		background: transparent;
		z-index: 1;
		.booking-menu__content,
		.booking-menu__item,
		ul {
			justify-content: left;
		}
		ul {
			margin-right: 0;
		}
		@include for-tablet-portrait-up {
			.booking-menu__item,
			ul {
				justify-content: center;
			}
			ul {
				margin-right: 35px;
			}
		}
		.booking-menu__item {
			width: 50%;

			padding: 12px 0;
			text-align: left;
			@include for-tablet-portrait-up {
				width: auto;
				padding: 12px 35px;
				text-align: center;
			}
		}

		.booking-menu__check {
			float: left;
			margin-right: 10px;
			@include for-tablet-portrait-up {
				float: none;
				margin-right: 0;
			}
		}

		.grid-container {
			padding: 0;
		}
		ul li {
			.booking-menu__uncheck {
				display: block;
				background-color: $colorPrimary2;
				@include for-tablet-portrait-up {
					display: none;
				}
				& ~ span {
					color: $colorPrimary7;
				}
			}
		}
		li {
			a {
				display: inline-block;
				> svg {
					display: none;
					@include for-tablet-portrait-up {
						display: inline-block;
					}
				}
				&:hover {
					svg {
						fill: $colorPrimary7;
					}
					.booking-menu__label {
						color: $colorPrimary7;
					}
				}

				.booking-menu__label {
					font-size: 20px;
					display: inline-block;
					@include for-tablet-portrait-up {
						font-size: 14px;
					}
				}
				.booking-menu__check {
					display: inline-block;
					position: relative;
					top: auto;
					right: auto;
				}

				@include for-tablet-portrait-up {
					display: block;
					.booking-menu__label {
						display: block;
					}
					.booking-menu__check {
						display: block;
						position: absolute;
						top: 45px;
						right: 0;
					}
				}
			}
			.booking-menu__icon {
				fill: $colorPrimary5;
			}
			.booking-menu__label {
				color: $colorPrimary5;
			}
			.booking-menu__check {
				background-color: $colorPrimary5;
			}
			&:after,
			&:nth-child(odd):before {
				content: '';
				background: $colorPrimary1;
			}
			&:after,
			&:before,
			&:nth-child(odd):before {
				content: '';
				width: 0px;
			}
			@include for-tablet-portrait-up {
				&:after,
				&:before,
				&:nth-child(odd):before {
					content: '';
					width: 1px;
				}
			}
		}
	}

	&__button {
		display: block;
		// padding: 0 30px 0 30px;
		// height: 40px;
		border: none;
		background-color: #59bdf6;
		color: $colorWhite;
		cursor: pointer;
		box-shadow: 0px 5px 10px -5px rgba(8, 86, 111, 0.2);
		text-shadow: 1px 1px rgba(0, 0, 0, 0.1);
		font-size: 16px;
		font-weight: 500;
		font-family: 'Saira', sans-serif;
		text-decoration: none;
		text-align: center;
		// line-height: 40px;
		margin: 20px 0;

		// height: auto;
		line-height: 1.2;
		padding: 14px 30px;

		@include for-tablet-portrait-up {
			margin: 0;
		}

		&.disabled {
			background-color: #d4f1fe;
			cursor: auto;
		}

		&--disable {
			background-color: #59bdf6;
		}

		&:hover {
			background-color: #4ba1d3;
			color: $colorWhite;
			text-decoration: none;
			&.disabled {
				background-color: #d4f1fe;
			}
		}
	}
}
</style>
